import { Injectable } from '@angular/core'

@Injectable()
export class GenService{
    private static monthNamesFull:Array<string> = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    private static monthNamesShort:Array<string> = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    private static dayNames :Array<string> = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    private milliSecsPerDay:number = 24 * 60 * 60 * 1000;
    private weekStartDay:number = 1; 

    constructor(){
    }    
    public static getGUID(): string {
        return (this.S4() + this.S4() + "-" + this.S4() + "-4" + this.S4().substr(0, 3) + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4()).toLowerCase();
    }
    public static convToDateNum(_dt:Date):number{
        if(_dt){
            return _dt.getTime();
        }
        return 0;
    }
    public static convToDate(_dateJson:any):Date{
        if(typeof _dateJson == "number"){
            if(_dateJson == 0)
                return null;
            return new Date(_dateJson);
        }
        if(typeof _dateJson == "string"){
            return new Date(_dateJson);
        }
        return null;
    }
    public static convToBoolNum(_bool:boolean):number{
        if(_bool == true) return 1;
        if(_bool == false) return 0;
        return -1;
    }
    public static areDatesSame(_d1:Date,_d2:Date){
        return _d1 && _d2 && (_d1.getDate() == _d2.getDate()) && (_d1.getMonth() == _d2.getMonth()) && (_d1.getFullYear() == _d2.getFullYear());
    }

    private static Alphabets:string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    public static getExcelColumnName(_index:number){
        let _retVal:string = '';
        do{
            var _tmp = _index % 26;

            _retVal = GenService.Alphabets[_tmp] + _retVal;
            _index =  Math.floor(_index/26) - 1;
        }while(_index >= 0)
        return _retVal;
    }
    
    private static S4(): string {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    getDatesForWeek(_weekNum:number, _year:number):Array<Date>{
        let _dates:Array<Date> = [];
        let _stDate:Date = this.getStartDateOfWeek(_weekNum,_year);
        for(var i=0;i<7;i++){
            let _newDate:Date = new Date(_stDate);
            _newDate.setDate(_stDate.getDate() + i);
            _dates.push(_newDate);
        }
        return _dates;
    }
    getWeekNumbersForMonth(year:number,month:number):Array<number>{
        let _weekNums:Array<number> = [];
        let _monthStDate = new Date(year,month-1,1);
        let _monthEdDate = new Date(_monthStDate.getFullYear(),_monthStDate.getMonth()+1,0);

        let _weekSt = this.getWeekNum(_monthStDate);
        let _weekEd = this.getWeekNum(_monthEdDate);

        for(var i = _weekSt; i <= _weekEd;i++){
            _weekNums.push(i);
        }

        return _weekNums;
    }
    getWeekNum(_date:Date):number{//ISO-8601
        let jan1 = new Date(_date.getFullYear(), 0, 1);
        let dayOffset:number =  this.getDayOffsetOfYear(jan1.getDay());
        //return Math.ceil((((_date.getTime() - jan1.getTime()) / this.milliSecsPerDay) + dayOffset + 1) / 7);
        return Math.ceil((((_date.getTime() - jan1.getTime()) / this.milliSecsPerDay) + dayOffset) / 7);
    }
    getStartDateOfWeek(_weekNum:number, _year:number):Date{
        let jan1 = new Date(_year, 0, 1);
        let dayOffset:number =  this.getDayOffsetOfYear(jan1.getDay());
        jan1.setDate(jan1.getDate() + ((_weekNum -1) * 7) - dayOffset )
        return jan1;
    }
    getDayNumOfyear(_date:Date):number{
        let jan1 = new Date(_date.getFullYear(), 0, 1);
        let dayOffset:number =  this.getDayOffsetOfYear(jan1.getDay());
        return Math.ceil((((_date.getTime() - jan1.getTime()) / this.milliSecsPerDay) + dayOffset + 1));
    }
    public static getMonthDispName(_year:number, _monthIndex:number){
        if(_year && this.monthNamesShort[_monthIndex]){
            return _year +'-' + this.monthNamesShort[_monthIndex];
        }
        return '-';
    }
    public static getDateFormatStr(_date:Date, _format:string):string{
        if(typeof _date == 'string'){
            _date = new Date(_date);
        }
        if(_date == null || _date.getTime() == 0){
            return "";
        }
        switch(_format){
            case "MMM YYYY":
                return this.monthNamesFull[_date.getMonth()] + ' ' +_date.getFullYear();
            case "DD MMM YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + ' ' + this.monthNamesFull[_date.getMonth()] + ' ' +_date.getFullYear();
            case "DD-MM-YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + ((_date.getMonth() + 1) < 10 ? '0' : '') + (_date.getMonth() + 1) + '-' +_date.getFullYear();
            case "DD-MMM-YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesFull[_date.getMonth()] + '-' +_date.getFullYear();
            case "DD-mmm-YYYY":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesShort[_date.getMonth()] + '-' +_date.getFullYear();
            case "d-mmm-YY":
                return _date.getDate() + '-' + this.monthNamesShort[_date.getMonth()] + '-' +(_date.getFullYear() % 2000);
            case "DD MMM":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + ' ' + this.monthNamesFull[_date.getMonth()];
            case "DD-MMM":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesFull[_date.getMonth()];
            case "DD-mmm":
                return (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + '-' + this.monthNamesShort[_date.getMonth()];
            case "DD/MMM/YY HH:mm:ss":
                return this.prepZeros(_date.getDate(),2) + '-' + this.monthNamesShort[_date.getMonth()] + '-' 
                      + (_date.getFullYear() % 100) + ' ' + this.prepZeros(_date.getHours(),2) + ':' 
                      + this.prepZeros(_date.getMinutes(), 2) + ':' + this.prepZeros(_date.getSeconds(), 2);
            case "mmm-YY":
                return this.monthNamesShort[_date.getMonth()] + '-' +(_date.getFullYear() % 2000);
            case "MMM-YYYY":
                return this.monthNamesFull[_date.getMonth()] + '-' +_date.getFullYear();            
            case "YYYYMMDD":
                return _date.getFullYear() + '' + ((_date.getMonth() + 1) < 10 ? '0' : '') + (_date.getMonth()+1) +
                       (_date.getDate() < 10 ? '0' : '')+ _date.getDate();
            case "YYYYMM":
                       return _date.getFullYear() + '' + ((_date.getMonth() + 1) < 10 ? '0' : '') + (_date.getMonth()+1);
            case "W, MMM DD, YYYY":
                return this.dayNames[_date.getDay()] + ', ' +this.monthNamesFull[_date.getMonth()] + ' ' + (_date.getDate() < 10 ? '0' : '')+ _date.getDate() + ', ' +_date.getFullYear();
            case "HHMMSS":
                return this.prepZeros(_date.getHours(),2) + '' 
                      + this.prepZeros(_date.getMinutes(), 2) + '' + this.prepZeros(_date.getSeconds(), 2);
        }
        return "";
    }

    parseDateString(_dateStr:string, _format:string):Date{
        _dateStr += '';
        switch(_format){
            case "YYYYMMDD":
                if(_dateStr.length == 8){
                    return new Date(parseInt(_dateStr.substring(0,4),10),
                                    parseInt(_dateStr.substring(4,6),10) - 1,
                                    parseInt(_dateStr.substring(6,8),10));
                }
                break;
        }
        return null;
    }
    private static prepZeros(_number:number,_reqNoOfDigits:number):string{
        let _retVal = _number + '';
        while(_retVal.length < _reqNoOfDigits){
            _retVal = '0' + _retVal;
        }
        return _retVal;
    }
    private getDayOffsetOfYear(_dayofWeek:number):number{
        switch(_dayofWeek){
            case 0: return -1;
            case 1: return 0;
            case 2: return 1;
            case 3: return 2;
            case 4: return 3;
            case 5: return -3;
            case 6: return -2;
        }
        return 0;
    }

    public static extractNameFromEmail(_email:string){
        let _tokens = _email.split('@');
        if(_tokens.length > 1){
            let _inTokens = _tokens[0].split(/[-.]+/)
            
            let _retVal = '';
            for(var i=0;i<_inTokens.length;i++){
                _retVal += _inTokens[i].charAt(0).toUpperCase() + _inTokens[i].substring(1) +
                            ( i < _inTokens.length - 1 ? ' ' : '');
            }
            return _retVal;
        }
        return '';
    }
    parseDateFromString(dateStr: string){
        if (!dateStr) {
            return null;
        }
        else {
            const formattedDateString =
                dateStr.substring(0, 4) + '-' +
                dateStr.substring(4, 6) + '-' +
                dateStr.substring(6, 8);

            // Use Date.parse() to get the timestamp (milliseconds)
            const timestampInMs = Date.parse(formattedDateString)
            // console.log("Parsed Date:", timestampInMs);
            return timestampInMs;
        }
    }
}